export const baseUrl = "http://admin.inkitsolutions.ch/";
var hostname = window.location.host;
export const urlWithoutPort = `http://${hostname}/`;